import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { SearchBrands, SearchBrandsVariables } from "./types/SearchBrands";

export const searchBrands = gql`
  ${pageInfoFragment}
  query SearchBrands(
    $after: String
    $first: Int!
    $query: String!
    $mallId: ID
    $status: SmopStatusEnum
    $mallsId: [ID]
    $accountManager: ID
  ) {
    search: brands(
      after: $after
      first: $first
      filter: {
        search: $query
        mall: $mallId
        malls: $mallsId
        accountManager: $accountManager
      }
      status: $status
    ) {
      edges {
        node {
          id
          name
          legalName
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchBrands, SearchBrandsVariables>(
  searchBrands
);
